module.exports = __webpack_public_path__ + "img/header-logo.d44d9718.png";